import { z } from 'zod';

export const LetterSchema = z.object({
  appearance: z.string(),
  pronunciations: z.array(z.string()),
  file: z.string().optional(),
});

export type Letter = z.infer<typeof LetterSchema>;
